export const datePickerConfig = () => {
  return {
    light: {
      dateSelectedBackground: '{green.500}',
      dateSelectedColor: 'var(--white)'
    },

    dark: {
      dateSelectedBackground: '{green.500}',
      dateSelectedColor: 'var(--white)'
    }
  }
}

export const datePickerPt = (instance?: any) => {
  if (!instance || !instance.attrs?.class?.includes('size-large')) return
  return {
    selectMonth: 'font-16-b',
    selectYear: 'font-16-b',
    month: 'font-16-n',
    decade: 'font-16-n',
    year: 'font-16-n',
    day: 'font-16-n'
  }
}
